<template>
  <div class="noselect draggable-item" @mousedown="on_mouse_down(item, $event)">
    <div class="icon-box" >
      <span class="ml-svg-icon svg-icon icon-inherit">
        <inline-svg v-if="item.svg" :src="item.svg"></inline-svg>
      </span>
    </div>
    <span class="component-name-wrapper">
      <span ref="labelText" class="component-name" v-html="formattedName"></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'WebBuilderToolButton',
  emits: ['start-drag'],
  props: ['item'],
  data() {
    return {
      
    };
  },
  computed: {
    formattedName() {
      return this.item.name.replace(/ *- */g, '<br>').toUpperCase();
    },
    itemStyle() {
      return {
        width: '102px', // large square width
        height: '102px', // large square height
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #ddd',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        margin: '10px',
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.labelText;
      if (!el) return;

      const parentWidth = el.parentNode.offsetWidth;
      const textWidth = el.scrollWidth;

      if (textWidth > parentWidth) {
        const scale = parentWidth / textWidth;
        el.style.transform = `scale(${scale})`;
      }
    });
  },
  methods: {
    on_mouse_down(item, event, index) {
      console.log('on_mouse_down tool start', event.clientX, event.clientY);
      this.$emit('start-drag', item, { x: event.clientX, y: event.clientY });
    },
    
  },
};
</script>

<style scoped>
.draggable-item {
  border: 1px solid #dedede;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 102px;
  height: 102px;
  background-color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.draggable-item:hover {
  transform: scale(1.05); /* Slight zoom-in effect on hover */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Enhanced shadow on hover */
}

.icon-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: auto;
  margin-bottom: 8px; /* more space between icon and text */
}

.icon {
  font-size: 24px; /* Size of the icon */
}

.component-name {
  font-size: 14px;
  color: #333;
  text-align: center;
}

:focus {
  outline: none !important; /* Prevent focus style while dragging */
}
body {
  user-select: none; /* Disable text selection */
}
.noselect {
  -webkit-user-select: none; /* Safari */
  user-select: none; /* Non-prefixed version, 
                        currently supported by all other modern browsers */
}

.ml-svg-icon svg path,
.ml-svg-icon svg rect,
.ml-svg-icon svg circle,
.ml-svg-icon svg g {
  fill: none !important;
  stroke: currentColor !important;
  stroke-width: 2;
}


.ml-svg-icon {
  margin-top: 20px;
  width: 46px;
  height: 46px;
  color: rgb(59, 59, 59);
  position: relative;
}

.ml-svg-icon svg {
  width: 46px;
  height: 46px;
}

.component-name-wrapper {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

.component-name {
  font-size: 13px;
  color: rgb(59, 59, 59);
  text-align: center;
  padding: 0 8px;
  max-width: 100%;
  box-sizing: border-box;
  display: inline-block;
  white-space: normal; /* ✅ allow line breaks */
  overflow-wrap: anywhere; /* ✅ force breaks if needed */
  line-height: 1.2;
}
</style>
